import React from 'react';
import { Button } from '../Button/Button';

interface PeopleDetailEmptyProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const PeopleDetailEmpty: React.FC<PeopleDetailEmptyProps> = ({
  icon,
  title,
  description,
  buttonText,
  onButtonClick
}) => {
  return (
    <div className="flex flex-col items-center justify-center text-center">
      {/* Icon */}
      <div className="mb-6">{icon}</div>

      <h3 className="text-[24px] font-bold text-[#353535] mb-2">{title}</h3>

      <p className="text-[16px] text-[#353535] mb-6">{description}</p>

      {buttonText && (
        <Button
          btnStyle="primary"
          onClick={onButtonClick}
          className="px-6 py-2 bg-[#49712B] text-white rounded-lg hover:bg-[#3d5d23] transition-colors text-[14px] font-semibold">
          {buttonText}
        </Button>
      )}
    </div>
  );
};
